import { useSelector } from 'react-redux';
import { CanteiroAreiaItem, CanteiroAreiaListResponse } from '../../../../../../../services/sementes/canteiroAreia';
import ListaCanteiroAreiaItem from './ListaCanteiroAreiaItem';
import PaginacaoSementes from '../PaginacaoSementes';
import { selectTopBarState } from '../../../../../../../components/Topbar/topBarSlice';

interface Props {
  items: CanteiroAreiaItem[];
  loading: boolean;
  error: string | null;
  meta: CanteiroAreiaListResponse['meta'] | null;
  onPageChange: (page: number) => void;
}

export default function ListaCanteiroAreia({
  items, loading, error, meta, onPageChange,
}: Props) {
  const { currentProdutor } = useSelector(selectTopBarState);

  if (!currentProdutor) {
    return (
      <div style={{
        textAlign: 'center',
        padding: '3rem 2rem',
        color: '#666',
        fontSize: '16px',
        backgroundColor: '#f9f9f9',
        borderRadius: '8px',
        margin: '2rem 0',
      }}
      >
        <i className="pi pi-info-circle" style={{ fontSize: '2rem', marginBottom: '1rem', display: 'block' }} />
        <strong>Nenhum produtor selecionado</strong>
        <p style={{ marginTop: '0.5rem', fontSize: '14px' }}>
          Selecione um produtor no cabeçalho para visualizar as análises
        </p>
      </div>
    );
  }

  if (loading) {
    return <div>Carregando...</div>;
  }

  if (error) {
    return <div>Erro: {error}</div>;
  }

  return (
    <div className="table">
      <div className="header">
        <div>Requerente</div>
        <div>N° Amostra</div>
        <div>Espécie</div>
        <div>Data de Entrada</div>
        <div>Status</div>
        <div>Amostra 1</div>
        <div>Amostra 2</div>
        <div>Média</div>
        <div />
      </div>
      {
        items.map((item) => (
          <ListaCanteiroAreiaItem
            key={item.id}
            id={item.id}
            produtor={item.produtor}
            nAmostra={item.nAmostra}
            especie={item.especie}
            dataEntrada={item.dataEntrada}
            status={item.status}
            amostra1={item.amostra1}
            amostra2={item.amostra2}
            media={item.media}
          />
        ))
      }

      {meta && (
        <PaginacaoSementes
          currentPage={meta.currentPage}
          totalPages={meta.totalPages}
          totalItems={meta.totalItems}
          perPage={meta.perPage}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
}
